import { PROMOTION_CAMPAIGN_TYPE } from "../../constants/status";

export class PromotionCampaign {
  _id: string = "";
  name: string = "";
  description: string = "";
  type: PROMOTION_CAMPAIGN_TYPE = PROMOTION_CAMPAIGN_TYPE.COMBO;
  created_at: string = "";
  updated_at: string = "";
  reference_table: string = "";

  constructor(data?: Partial<PromotionCampaign>) {
    Object.assign(this, data);
  }
}




